import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import axios, { API } from "@/lib/api";

function formatDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
}

export default function ArticlesPreview() {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/public/articles`, { params: { limit: 3 } }).then(({ data }) => setArticles(data.items)).catch(() => {});
  }, []);

  return (
    <section className="bg-[#F5F9F7] py-20" data-testid="articles-preview-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Artikel</span>
            <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Wawasan &amp; Berita Terbaru</h2>
          </div>
          <Button variant="outline" data-testid="articles-view-all-button" onClick={() => navigate("/artikel")} className="gap-2 rounded-full">
            Lihat Semua <ArrowRight className="h-4 w-4" />
          </Button>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {articles.map((a) => (
            <button key={a.id} data-testid={`article-card-${a.id}`} onClick={() => navigate(`/artikel/${a.slug}`)} className="overflow-hidden rounded-2xl bg-white text-left shadow-[0_2px_16px_rgba(15,107,79,0.06)] transition-all duration-300 hover:-translate-y-1">
              <img src={a.cover_image} alt={a.title} className="h-44 w-full object-cover" />
              <div className="p-5">
                <Badge variant="outline" className="rounded-full border-[#0F6B4F]/30 text-[#0F6B4F]">{a.category}</Badge>
                <h3 className="mt-3 font-heading text-base font-semibold text-[#1F2937] line-clamp-2">{a.title}</h3>
                <p className="mt-2 text-sm text-[#64748B] line-clamp-2">{a.excerpt}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-[#64748B]">
                  <span>{formatDate(a.published_at)}</span>
                  <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {a.reading_time} menit</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
